import * as React from 'react';

import config from 'js/app/config';
import path from 'js/lib/path';

import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';
import CategoryPageGoogleSchemaMarkup from 'bundles/shared-articles/components/seo/CategoryPageGoogleSchemaMarkup';
import { generatePaginationProperties } from 'bundles/shared-articles/utils/seoUtils';
import { getSEOContentTitle } from 'bundles/unified-seo-content-common/constants';
import type { PageData } from 'bundles/unified-seo-content-common/pages/resource/ResourceCategoryPage';
import type { SEOContentPageType } from 'bundles/unified-seo-content-common/types';

type Props = {
  pageData: PageData;
  hubPageLink: string;
  pageType: SEOContentPageType;
  currentPageNumber: number;
  pageCount: number;
  pathname: string;
};

const CategoryPageSEO = ({ pageData, hubPageLink, currentPageNumber, pageCount, pathname, pageType }: Props) => {
  const { title, introduction, metaTitle, metaDescription } = pageData;

  if (!title || !introduction) {
    return null;
  }

  const urlDomain = config.url.domain;
  const pageUrl = path.join(urlDomain, pathname);

  const paginationProperties = generatePaginationProperties({ pageCount, currentPageNumber, pageUrl });

  return (
    <React.Fragment>
      <CourseraMetatags
        metaNameAndProperties={{
          title: metaTitle || title,
          ogAndTwitterTitle: metaTitle || title,
          description: metaDescription || introduction,
          disableCourseraDescriptionSuffix: true,
        }}
        paginationProperties={paginationProperties}
        hrefLangOverrides={() => []}
      />
      <CategoryPageGoogleSchemaMarkup
        categoryPageUrl={pageUrl}
        categoryBreadcrumbList={[
          { name: getSEOContentTitle(pageType), absoluteUrl: path.join(urlDomain, hubPageLink) },
          { name: title, absoluteUrl: pageUrl },
        ]}
        categoryPageName={title}
      />
    </React.Fragment>
  );
};

export default CategoryPageSEO;
